































import Vue from "vue";
import { formatCurrency } from "@/utility/Formatter";

// Vue Components
import TransactionPropsList from "@/components/PropsLists/TransactionPropsList.vue";
import CashDetailsCard from "./CashDetailsCard.vue";

// Model
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";

export default Vue.extend({
    components: {
        TransactionPropsList,
        CashDetailsCard,
    },
    data() {
        return {
            TransactionFlowEnum,
        };
    },
    props: {
        transaction: {},
    },
    methods: {
        formatCurrency,
    },
});
